import { useEffect, useState } from 'react';

import showModal from 'react-scale/components/tailwind/Modal/showModal';
import { Header, HeroBigWebGL } from 'react-scale/components';
import Modal from 'react-scale/components/tailwind/Modal';
import Form from 'react-scale/components/pages/resources/detail/form';

const Hero = () => {
  const [hasRegistered, setHasRegistered] = useState(false);
  const { isShowing, toggle, setIsShowing } = showModal();

  useEffect(() => {
    const hasRegisteredStorage = window.localStorage.getItem('hasregistered');

    if (hasRegisteredStorage === 'oxford') {
      setHasRegistered(true);
    }
  }, [isShowing]);

  return (
    <div id="download">
      <div className="relative">
        <Header
          title="Oxford Open Dataset - Scale"
          canonical="https://scale.com/open-av-datasets/oxford"
          favicon="open-datasets/oxford"
          ogImg="/static/images/pages/open-datasets/oxford/og.png"
          twImg="/static/images/pages/open-datasets/oxford/og.png"
        />
        <HeroBigWebGL
          webgl={{
            style: {
              '--gradient-color-1': '#438BDD',
              '--gradient-color-2': '#438BDD',
              '--gradient-color-3': '#000',
              '--gradient-color-4': '#000'
            }
          }}
          title="Debagreement: Reddit&nbsp;50K"
          subtitle="Open-source agreement / disagreement dataset of Reddit interactions developed in partnership with Oxford&nbsp;University."
          cta={
            hasRegistered
              ? {
                  buttons: [
                    {
                      href: 'https://drive.google.com/drive/u/0/folders/1zr_ezGwcgZPB0-oWy4YC56SOyg5ig3jy',
                      text: 'Download Dataset',
                      type: 'primary',
                      borderColor: '#438BDD'
                    }
                  ],
                  hubspotForm: false,
                  hubspotModal: false
                }
              : {
                  hubspotModal: {
                    formId: '03e2e30e-b16c-4dd7-a567-ac7cd1881507',
                    label: 'Download Dataset',
                    buttons: { borderColor: '#438BDD' }
                  }
                }
          }
        />
      </div>
      <Modal isShowing={isShowing} hide={() => setIsShowing(false)} title="Download Dataset">
        <Form
          portalId="4823527"
          formId="03e2e30e-b16c-4dd7-a567-ac7cd1881507"
          slug="oxford"
          hideModalAfterSubmit={toggle}
          downloadValidation
        />
      </Modal>
    </div>
  );
};

export default Hero;
